export const addIcons = (text: string) =>
  text
    .replace('[editIcon]', '<img src="/assets/icon-edit-white.svg">')
    .replace('[deleteIcon]', '<img src="/assets/action-delete-white.svg">');
